var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.75 8.5C3.75 7.5335 4.5335 6.75 5.5 6.75H26.5C27.4665 6.75 28.25 7.5335 28.25 8.5V23.5C28.25 24.4665 27.4665 25.25 26.5 25.25H5.5C4.5335 25.25 3.75 24.4665 3.75 23.5V8.5ZM5.5 5.25C3.70507 5.25 2.25 6.70507 2.25 8.5V23.5C2.25 25.2949 3.70507 26.75 5.5 26.75H26.5C28.2949 26.75 29.75 25.2949 29.75 23.5V8.5C29.75 6.70507 28.2949 5.25 26.5 5.25H5.5ZM7.46046 9.40799C7.13349 9.15368 6.66229 9.21258 6.40799 9.53954C6.15368 9.86651 6.21258 10.3377 6.53954 10.592L15.5395 17.592C15.8104 17.8027 16.1896 17.8027 16.4605 17.592L25.4605 10.592C25.7874 10.3377 25.8463 9.86651 25.592 9.53954C25.3377 9.21258 24.8665 9.15368 24.5395 9.40799L16 16.0499L7.46046 9.40799Z","fill":"#222729"}));
}

Mail.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
